/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Dependancies React=================
import { useSelector, useDispatch } from 'react-redux';
import {
  useCallback, useEffect, useMemo, useRef,
} from 'react';

// ==================Style&IMG===================
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './style.scss';

// =================Ag grid===================
import { AgGridReact } from 'ag-grid-react';
// =================Actions===================
import {
  exportCsv,
  saveAgencyGridFilter,
  saveAntennaTypeSelected,
  saveCellMouseOutMarker,
  saveCellMouseOverMarker,
  saveCityGridFilter,
  saveCountryGridFilter,
  saveDataGridRows,
  saveInvertedNetwork,
  saveMarkerGridFilter,
  saveNetworkGridFilter,
  saveRadomeTypeSelected,
  saveReceiverTypeSelected,
  saveSatelliteSystemSelected,
  saveSiteNameGridFilter,
  saveStateGridFilter,
  saveStringToClipboard,
  setAttributeChannel,
  setClearButton,
  setClockQc,
  setCycleQc,
  setDailyObservation,
  setDataAvailability,
  setDataGridRows,
  setDatePickerAdvancedSearchDateFrom,
  setDatePickerAdvancedSearchDateTo,
  setElevationQc,
  setEpochQc,
  setFileStatusSelected,
  setFileTypeSelected,
  setFrequenciesBand,
  setGreaterAlt,
  setGreaterEndDate,
  setGreaterInstallDate,
  setGreaterLat,
  setGreaterLon,
  setLessAlt,
  setLessEndDate,
  setLessInstallDate,
  setLessLat,
  setLessLon,
  setMultipathQc,
  setNewList,
  setObservationsTypes,
  setSatelliteSystemQc,
  setSaveCountryQuery,
  setSelectAll,
  setSelectAllClick,
  setSinglePointQc,
  setToolsCheckbox,
} from '../../../actions/site';
import { setSaveMarkerSelected } from '../../../actions/multipleMetadata';

// =================Composant===================
import linkMarker from './linkMarker';
import buttonNetwork from './buttonNetwork';
import numberLatFloatingFilterComponent from './numberLatFloatingFilterComponent';
import numberLonFloatingFilterComponent from './numberLonFloatingFilterComponent';
import numberAltFloatingFilterComponent from './numberAltFloatingFilterComponent';
import dateInstallDateFilter from './dateInstallDateFilter';
import dateEndDateFilter from './dateEndDateFilter';
import networkFilter from './networkFilter';
import { setChargingNewListStations } from '../../../actions/dataAPI';

function DataGrid() {
  // ================= Refs =========================
  const gridRef = useRef();
  const lastModifiedRef = useRef(null);
  // ==================HOOK=========================
  const dispatch = useDispatch();
  const dataGrid = useSelector((state) => state.dataAPI.stations.list);
  const greaterLat = useSelector((state) => state.site.filter.greaterLat);
  const lessLat = useSelector((state) => state.site.filter.lessLat);
  const greaterLon = useSelector((state) => state.site.filter.greaterLon);
  const lessLon = useSelector((state) => state.site.filter.lessLon);
  const greaterAlt = useSelector((state) => state.site.filter.greaterAlt);
  const lessAlt = useSelector((state) => state.site.filter.lessAlt);
  const greaterInstallDate = useSelector((state) => state.site.filter.greaterInstallDate);
  const lessInstallDate = useSelector((state) => state.site.filter.lessInstallDate);
  const greaterEndDate = useSelector((state) => state.site.filter.greaterEndDate);
  const lessEndDate = useSelector((state) => state.site.filter.lessEndDate);
  const clearButton = useSelector((state) => state.site.clear);
  const marker = useSelector((state) => state.site.filter.marker);
  const country = useSelector((state) => state.site.filter.country);
  const siteName = useSelector((state) => state.site.filter.siteName);
  const stateGrid = useSelector((state) => state.site.filter.state);
  const city = useSelector((state) => state.site.filter.city);
  const agency = useSelector((state) => state.site.filter.agency);
  const network = useSelector((state) => state.site.filter.network);
  const invertedNetwork = useSelector((state) => state.site.filter.invertedNetwork);
  const copyStringToClipboard = useSelector((state) => state.site.stringToClipboard);
  const exportCsvData = useSelector((state) => state.site.exportCsv);
  const markerSelectedArray = useSelector(
    (state) => state.multipleMetadata.dataMultiple.markerSelectedArray,
  );
  const tools = useSelector((state) => state.site.networks.tools);
  const stateRowsDataGrid = useSelector((state) => state.site.dataGrid.dataGridRows);
  const dataAPI = useSelector((state) => state.dataAPI.stations.list);
  const clickNetwork = useSelector((state) => state.site.networks.selectAllClick);
  const selectedMarkersOnMap = useSelector((state) => state.site.selectedMarkers);
  const newListStations = useSelector((state) => state.dataAPI.stations.newList);
  const networks = useSelector((state) => state.site.networks.listNetworks);

  const showInactive = tools[1]?.checked;

  const allNetworksChecked = (networks || []).every((n) => n.checked);
  const lastListRef = useRef([]);

  const stationMap = useMemo(() => {
    const map = new Map();
    if (dataAPI.data) {
      dataAPI.data.forEach((station) => {
        map.set(station.marker_long_name, station);
      });
    }
    return map;
  }, [dataAPI.data]);

  const buildDataToSave = useCallback(() => {
    if (!dataAPI.data) return [];

    const allowedNetworks = new Set(
      (networks || []).filter((n) => n.checked).map((n) => n.name[0]),
    );

    const filtered = dataAPI.data.filter((st) => {
      const stationNetworks = st.network.name
        .split(/\s*[&/+,]\s*/)
        .map((n) => n.trim());

      const passNetwork = allNetworksChecked || stationNetworks.some((n) => allowedNetworks.has(n));

      const passInactive = showInactive
        ? true
        : st.date_to === null;

      return passNetwork && passInactive;
    });

    return [...filtered];
  }, [dataAPI.data, networks, showInactive]);

  const selectRowsFromMarkers = (selectedMarkers) => {
    if (!gridRef.current.api) return;

    gridRef.current.api.forEachNode((node) => {
      const shouldSelect = selectedMarkers.includes(node.data.marker);
      node.setSelected(shouldSelect);
    });
  };

  // ================= useEffect ======================
  useEffect(() => {
    selectRowsFromMarkers(selectedMarkersOnMap);
  }, [selectedMarkersOnMap]);

  useEffect(() => {
    const uncheckedNetworks = (networks || [])
      .filter((n) => !n.checked)
      .map((n) => n.name[0]);
    const invertedNetworkString = uncheckedNetworks.join(',');
    dispatch(saveInvertedNetwork(invertedNetworkString));
  }, [networks]);

  // ============== UseMemo ========================

  const defaultColDef = useMemo(() => ({
    flex: 1,
    minWidth: 100,
    sortable: true,
    resizable: true,
    filter: true,
    cellStyle: { textAlign: 'left' },
    suppressFloatingFilterButton: true,
  }), []);

  const isExternalFilterPresent = () => !showInactive;

  const doesExternalFilterPass = (node) => {
    if (!showInactive) {
      return node.data.endDate == null || node.data.endDate === '';
    }
    return true;
  };

  const filterParams = {
    maxNumConditions: 2,
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      let dateAsString = cellValue;
      if (dateAsString == null) return -1;
      dateAsString = dateAsString.substring(0, dateAsString.indexOf(' '));
      const dateParts = dateAsString.split('-');
      const cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2]),
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
  };

  const includeOrExclude = {
    filterOptions: [
      'contains',
      {
        displayKey: 'includedNetworks',
        displayName: 'includedNetworks',
        predicate: ([filterValue], cellValue) => {
          const networksList = cellValue.replace('.', '').split(' & ');
          let returnValue = false;
          networksList.forEach((elem) => {
            const name = elem;
            for (let i = 0; i < name.length; i += 1) {
              const separators = [','];
              const strippedValue = filterValue.split(separators);
              for (let y = 0; y < strippedValue.length; y += 1) {
                const sValueToTest = strippedValue[y].replace('\\', '');
                if (name.toLowerCase().indexOf(sValueToTest.toLowerCase()) === 0) {
                  returnValue = true;
                }
              }
            }
          });
          return returnValue;
        },
        numberOfInputs: 1,
      },
      {
        displayKey: 'excludedNetworks',
        displayName: 'excludedNetworks',
        predicate: ([filterValue], cellValue) => {
          if (cellValue == null) cellValue = 'N/A';

          const networksList = cellValue.replace(/\./g, '').split(' & ');

          const strippedValue = filterValue
            .split(',')
            .map((s) => s.trim().replace(/\\/g, '').replace(/\./g, '').toLowerCase());

          let returnValue = true;

          networksList.forEach((elem) => {
            const name = elem.trim().toLowerCase();
            strippedValue.forEach((sValueToTest) => {
              if (name.startsWith(sValueToTest)) {
                returnValue = false;
              }
            });
          });
          return returnValue;
        },
        numberOfInputs: 1,
      },
    ],
  };

  const columns = [
    {
      field: 'marker',
      headerName: 'Marker',
      minWidth: 120,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      suppressHeaderMenuButton: true,
      floatingFilter: true,
      sort: 'asc',
      cellRenderer: linkMarker,
      filterParams: {
        defaultOption: 'startsWith',
      },
    },
    {
      field: 'site',
      minWidth: 50,
      headerName: 'Site Name',
      suppressHeaderMenuButton: true,
      floatingFilter: true,
      filterParams: {
        defaultOption: 'startsWith',
      },
    },
    {
      field: 'lat',
      minWidth: 50,
      headerName: 'Latitude (°D)',
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      floatingFilterComponent: numberLatFloatingFilterComponent,
      suppressHeaderMenuButton: true,
      suppressFloatingFilterButton: true,
    },
    {
      field: 'lon',
      minWidth: 50,
      headerName: 'Longitude (°D)',
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      floatingFilterComponent: numberLonFloatingFilterComponent,
      suppressHeaderMenuButton: true,
      suppressFloatingFilterButton: true,
    },
    {
      field: 'alt',
      headerName: 'Altitude (m)',
      minWidth: 50,
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      floatingFilterComponent: numberAltFloatingFilterComponent,
      suppressHeaderMenuButton: true,
      suppressFloatingFilterButton: true,
    },
    {
      field: 'installDate',
      minWidth: 50,
      headerName: 'Install Date',
      filter: 'agDateColumnFilter',
      filterParams: filterParams,
      floatingFilter: true,
      floatingFilterComponent: dateInstallDateFilter,
      suppressHeaderMenuButton: true,
      suppressFloatingFilterButton: true,
    },
    {
      field: 'endDate',
      minWidth: 50,
      headerName: 'End Date',
      filter: 'agDateColumnFilter',
      filterParams: filterParams,
      floatingFilter: true,
      floatingFilterComponent: dateEndDateFilter,
      suppressHeaderMenuButton: true,
      suppressFloatingFilterButton: true,
    },
    {
      field: 'country',
      minWidth: 50,
      headerName: 'Country',
      suppressHeaderMenuButton: true,
      floatingFilter: true,
      filterParams: {
        defaultOption: 'startsWith',
      },
    },
    {
      field: 'state',
      minWidth: 50,
      headerName: 'State',
      suppressHeaderMenuButton: true,
      floatingFilter: true,
      filterParams: {
        defaultOption: 'startsWith',
      },
    },
    {
      field: 'city',
      minWidth: 50,
      headerName: 'City',
      suppressHeaderMenuButton: true,
      floatingFilter: true,
      filterParams: {
        defaultOption: 'startsWith',
      },
    },
    {
      field: 'agency',
      minWidth: 50,
      headerName: 'Agency',
      suppressHeaderMenuButton: true,
      floatingFilter: true,
      filterParams: {
        defaultOption: 'startsWith',
      },
    },
    {
      field: 'network',
      minWidth: 50,
      headerName: 'Network',
      filterParams: includeOrExclude,
      floatingFilterComponent: networkFilter,
      suppressHeaderMenuButton: true,
      floatingFilter: true,
      cellRenderer: buttonNetwork,
    },
  ];

  const clearAllFilter = useCallback(() => {
    const arrayOfColumn = ['marker', 'site', 'country', 'state', 'city', 'agency', 'network'];
    const arrayOfDoubleFilterColumn = ['lat', 'lon', 'alt', 'installDate', 'endDate'];
    for (let i = 0; i < arrayOfColumn.length; i += 1) {
      gridRef.current.api.setColumnFilterModel(arrayOfColumn[i], null).then(() => {
        gridRef.current.api.onFilterChanged();
      }, []);
    }
    for (let i = 0; i < arrayOfDoubleFilterColumn.length; i += 1) {
      gridRef.current.api.setColumnFilterModel(arrayOfDoubleFilterColumn[i], {
        type: 'greaterThan',
        filter: null,
      });
      gridRef.current.api.setColumnFilterModel(arrayOfDoubleFilterColumn[i], {
        type: 'lessThan',
        filter: null,
      });
    }
    const greaterInstallDateValue = document.getElementsByClassName('greaterInstallDate');
    const lessInstallDateValue = document.getElementsByClassName('lessInstallDate');
    const lessEndDateValue = document.getElementsByClassName('lessEndDate');
    const greaterEndDateValue = document.getElementsByClassName('greaterEndDate');

    if (greaterInstallDateValue[0]) greaterInstallDateValue[0].value = null;
    if (lessInstallDateValue[0]) lessInstallDateValue[0].value = null;
    if (lessEndDateValue[0]) lessEndDateValue[0].value = null;
    if (greaterEndDateValue[0]) greaterEndDateValue[0].value = null;

    dispatch(saveMarkerGridFilter(''));
    dispatch(saveAgencyGridFilter(''));
    dispatch(saveSiteNameGridFilter(''));
    dispatch(saveCountryGridFilter(''));
    dispatch(saveStateGridFilter(''));
    dispatch(saveCityGridFilter(''));
    dispatch(saveNetworkGridFilter(''));
    dispatch(saveInvertedNetwork(''));
    dispatch(setGreaterLat(''));
    dispatch(setLessLat(''));
    dispatch(setGreaterLon(''));
    dispatch(setLessLon(''));
    dispatch(setGreaterAlt(''));
    dispatch(setLessAlt(''));
    dispatch(setGreaterInstallDate(''));
    dispatch(setLessInstallDate(''));
    dispatch(setGreaterEndDate(''));
    dispatch(setLessEndDate(''));

    if (tools.length > 0) {
      const resetTools = tools.map((t, i) => (i === 0 || i === 1 ? { ...t, checked: true } : t));
      dispatch(setToolsCheckbox(resetTools));
    }

    dispatch(setSelectAllClick(true));

    if (document.getElementsByClassName('input--selectAll')[0]) {
      document.getElementsByClassName('input--selectAll')[0].checked = true;
    }

    gridRef.current.api.onFilterChanged();
  });

  const clearAdvancedSearch = useCallback(() => {
    dispatch(saveReceiverTypeSelected([]));
    if (document.getElementsByClassName('receiver--type')[0]) {
      document.getElementsByClassName('receiver--type')[0].selectedIndex = -1;
    }
    dispatch(saveAntennaTypeSelected([]));
    if (document.getElementsByClassName('antenna--type')[0]) {
      document.getElementsByClassName('antenna--type')[0].selectedIndex = -1;
    }
    dispatch(saveRadomeTypeSelected([]));
    if (document.getElementsByClassName('radome--type')[0]) {
      document.getElementsByClassName('radome--type')[0].selectedIndex = -1;
    }
    dispatch(saveSatelliteSystemSelected([]));
    if (document.getElementsByClassName('satellite--system')[0]) {
      document.getElementsByClassName('satellite--system')[0].selectedIndex = -1;
    }
    dispatch(setFileTypeSelected([]));
    if (document.getElementsByClassName('file--type')[0]) {
      document.getElementsByClassName('file--type')[0].selectedIndex = -1;
    }
    dispatch(setFileStatusSelected([]));
    if (document.getElementsByClassName('file--status')[0]) {
      document.getElementsByClassName('file--status')[0].selectedIndex = -1;
    }
    dispatch(setDatePickerAdvancedSearchDateFrom(''));
    dispatch(setDatePickerAdvancedSearchDateTo(''));
    dispatch(setDataAvailability(''));
    dispatch(setDailyObservation(''));
    dispatch(setObservationsTypes(''));
    if (document.getElementsByClassName('observations--types')[0]) {
      document.getElementsByClassName('observations--types')[0].selectedIndex = -1;
    }
    dispatch(setFrequenciesBand(''));
    if (document.getElementsByClassName('frequencies--band')[0]) {
      document.getElementsByClassName('frequencies--band')[0].selectedIndex = -1;
    }
    dispatch(setAttributeChannel(''));
    if (document.getElementsByClassName('attribute--channel')[0]) {
      document.getElementsByClassName('attribute--channel')[0].selectedIndex = -1;
    }
    dispatch(setSatelliteSystemQc(''));
    if (document.getElementsByClassName('satellite--system--qc')[0]) {
      document.getElementsByClassName('satellite--system--qc')[0].selectedIndex = -1;
    }
    dispatch(setEpochQc(''));
    dispatch(setElevationQc(''));
    dispatch(setMultipathQc(''));
    dispatch(setCycleQc(''));
    dispatch(setSinglePointQc(''));
    dispatch(setClockQc(''));
  });

  useEffect(() => {
    if (clearButton) {
      clearAllFilter();
      clearAdvancedSearch();
      gridRef.current.api.deselectAll();
      dispatch(setClearButton(false));
    }
  }, [clearButton]);

  useEffect(() => {
    if (exportCsvData) {
      dispatch(exportCsv(false));
      if (markerSelectedArray.length === 0) {
        gridRef.current.api.exportDataAsCsv();
      }
      else if (markerSelectedArray.length > 0) {
        gridRef.current.api.exportDataAsCsv({ onlySelected: true });
      }
    }
  }, [exportCsvData]);

  const buildRows = useCallback((stations) => {
    const rows = stations.map((st, i) => ({
      id: i,
      marker: st.marker_long_name,
      site: st.name,
      lat: st.location.coordinates.lat,
      lon: st.location.coordinates.lon,
      alt: st.location.coordinates.altitude,
      installDate: st.date_from,
      endDate: st.date_to,
      country: st.location.country?.name || '',
      state: st.location.state?.name || '',
      city: st.location.city?.name || '',
      agency: st.agency?.name || '',
      network: st.network?.name || '',
    }));
    dispatch(setDataGridRows(rows));
    dispatch(saveDataGridRows(rows));
  }, [dispatch]);

  useEffect(() => {
    if (dataAPI.data?.length) {
      buildRows(dataAPI.data);
      dispatch(setChargingNewListStations(true));
    }
  }, [dataAPI.data, buildRows]);

  // ================= Functions =========================

  // // ================= useEffect ======================

  const buildFilterModel = () => {
    const model = {};

    if (marker) {
      model.marker = { filterType: 'text', type: 'startsWith', filter: marker };
    }
    if (siteName) {
      model.site = { filterType: 'text', type: 'startsWith', filter: siteName };
    }
    if (country) {
      model.country = { filterType: 'text', type: 'startsWith', filter: country };
    }
    if (stateGrid) {
      model.state = { filterType: 'text', type: 'startsWith', filter: stateGrid };
    }
    if (city) {
      model.city = { filterType: 'text', type: 'startsWith', filter: city };
    }
    if (agency) {
      model.agency = { filterType: 'text', type: 'startsWith', filter: agency };
    }

    const isGreaterLatValid = typeof greaterLat === 'number' && !isNaN(greaterLat);
    const isLessLatValid = typeof lessLat === 'number' && !isNaN(lessLat);
    const isGreaterLonValid = typeof greaterLon === 'number' && !isNaN(greaterLon);
    const isLessLonValid = typeof lessLon === 'number' && !isNaN(lessLon);
    const isGreaterAltValid = typeof greaterAlt === 'number' && !isNaN(greaterAlt);
    const isLessAltValid = typeof lessAlt === 'number' && !isNaN(lessAlt);

    if (isGreaterLatValid || isLessLatValid) {
      model.lat = {
        filterType: 'number',
        operator: 'AND',
        conditions: [
          ...(isGreaterLatValid ? [{ type: 'greaterThan', filter: greaterLat }] : []),
          ...(isLessLatValid ? [{ type: 'lessThan', filter: lessLat }] : []),
        ],
      };
    }
    if (isGreaterLonValid || isLessLonValid) {
      model.lon = {
        filterType: 'number',
        operator: 'AND',
        conditions: [
          ...(isGreaterLonValid ? [{ type: 'greaterThan', filter: greaterLon }] : []),
          ...(isLessLonValid ? [{ type: 'lessThan', filter: lessLon }] : []),
        ],
      };
    }
    if (isGreaterAltValid || isLessAltValid) {
      model.alt = {
        filterType: 'number',
        operator: 'AND',
        conditions: [
          ...(isGreaterAltValid ? [{ type: 'greaterThan', filter: greaterAlt }] : []),
          ...(isLessAltValid ? [{ type: 'lessThan', filter: lessAlt }] : []),
        ],
      };
    }

    if (greaterInstallDate || lessInstallDate) {
      model.installDate = {
        filterType: 'date',
        operator: 'AND',
        conditions: [
          ...(greaterInstallDate ? [{
            filterType: 'date',
            type: 'greaterThan',
            dateFrom: greaterInstallDate,
          }] : []),
          ...(lessInstallDate ? [{
            filterType: 'date',
            type: 'lessThan',
            dateFrom: lessInstallDate,
          }] : []),
        ],
      };
    }
    if (greaterEndDate || lessEndDate) {
      model.endDate = {
        filterType: 'date',
        operator: 'AND',
        conditions: [
          ...(greaterEndDate ? [{
            filterType: 'date',
            type: 'greaterThan',
            dateFrom: greaterEndDate,
          }] : []),
          ...(lessEndDate ? [{
            filterType: 'date',
            type: 'lessThan',
            dateFrom: lessEndDate,
          }] : []),
        ],
      };
    }

    if (network || invertedNetwork) {
      model.network = {
        filterType: 'text',
        operator: 'AND',
        conditions: [
          ...(network ? [{ type: 'includedNetworks', filter: network }] : []),
          ...(invertedNetwork ? [{ type: 'excludedNetworks', filter: invertedNetwork }] : []),
        ],
      };
    }

    return model;
  };

  useEffect(() => {
    if (gridRef.current?.api) {
      const filterModel = buildFilterModel();
      gridRef.current.api.setFilterModel(filterModel);
    }
  }, [
    marker, siteName, greaterLat, lessLat, greaterLon, lessLon,
    greaterAlt, lessAlt, greaterInstallDate, lessInstallDate,
    greaterEndDate, lessEndDate, country, stateGrid, city,
    agency, network, invertedNetwork, networks,
  ]);

  const showMessage = () => {
    navigator.clipboard.writeText(copyStringToClipboard);
    alert(`Copied the text: ${copyStringToClipboard}`);
  };

  const keydownHandler = (e) => {
    if (e.key === 'c' && e.ctrlKey) showMessage();
  };
  useEffect(() => {
    document.addEventListener('keydown', keydownHandler);
    return () => {
      document.removeEventListener('keydown', keydownHandler);
    };
  }, [copyStringToClipboard]);

  const rows = stateRowsDataGrid;
  const cellRenderer = useCallback((event) => {
    if (event.node.selected === false) {
      dispatch(saveCellMouseOverMarker(event.data));
    }
  }, []);

  const cellRendererOut = useCallback((event) => {
    if (event.node.selected === false) {
      dispatch(saveCellMouseOverMarker({}));
      dispatch(saveCellMouseOutMarker(event.data));
    }
  }, []);
  const onSelectionChanged = useCallback((event) => {
    const rowSelected = event.api.getSelectedNodes();
    if (rowSelected.length > dataAPI.data.length - 1) {
      dispatch(setSelectAll(true));
    }
    else if (rowSelected.length === 0) {
      dispatch(setSelectAll(false));
    }
    const rowSelectedArray = [];
    rowSelected.map((el) => rowSelectedArray.push(el.data.marker));
    dispatch(setSaveMarkerSelected(rowSelectedArray));

    let stringToClipboard = '';
    rowSelected.forEach((node) => {
      Object.entries(node.data).forEach(([key, value]) => {
        stringToClipboard += `${key}: ${value}, `;
      });
    });

    dispatch(saveStringToClipboard(stringToClipboard));
  }, []);

  // ===================Hook AGgrid==================
  const onFilterModified = useCallback((e) => {
    lastModifiedRef.current = e.column.getColId();
    if (e.column.colId === 'marker') {
      if (e.filterInstance.appliedModel !== null) {
        dispatch(saveMarkerGridFilter(e.filterInstance.appliedModel.filter));
      }
      else {
        dispatch(saveMarkerGridFilter(''));
      }
    }
    if (e.column.colId === 'site') {
      if (e.filterInstance.appliedModel !== null) {
        dispatch(saveSiteNameGridFilter(e.filterInstance.appliedModel.filter));
      }
      else {
        dispatch(saveSiteNameGridFilter(''));
      }
    }
    if (e.column.colId === 'country') {
      if (e.filterInstance.appliedModel !== null) {
        dispatch(saveCountryGridFilter(e.filterInstance.appliedModel.filter));
      }
      else {
        dispatch(saveCountryGridFilter(''));
      }
    }
    if (e.column.colId === 'state') {
      if (e.filterInstance.appliedModel !== null) {
        dispatch(saveStateGridFilter(e.filterInstance.appliedModel.filter));
      }
      else {
        dispatch(saveStateGridFilter(''));
      }
    }
    if (e.column.colId === 'city') {
      if (e.filterInstance.appliedModel !== null) {
        dispatch(saveCityGridFilter(e.filterInstance.appliedModel.filter));
      }
      else {
        dispatch(saveCityGridFilter(''));
      }
    }
    if (e.column.colId === 'agency') {
      if (e.filterInstance.appliedModel !== null) {
        dispatch(saveAgencyGridFilter(e.filterInstance.appliedModel.filter));
      }
      else {
        dispatch(saveAgencyGridFilter(''));
      }
    }
  }, []);
  useEffect(() => {
    if (gridRef.current?.api) {
      gridRef.current.api.onFilterChanged();
    }
  }, [showInactive]);

  const onFilterChanged = useCallback(() => {
    if (!gridRef.current?.api || !dataAPI.data) return;

    const visibleMarkers = new Set();
    gridRef.current.api.forEachNodeAfterFilter((node) => {
      visibleMarkers.add(node.data.marker);
    });

    const filteredStations = dataAPI.data.filter((station) => visibleMarkers.has(station.marker_long_name));

    const prevList = lastListRef.current;
    const sameLength = filteredStations.length === prevList.length;
    const sameContent = sameLength && filteredStations.every(
      (st, i) => st.marker_long_name === prevList[i]?.marker_long_name,
    );

    if (!sameContent) {
      lastListRef.current = filteredStations;
      dispatch(setNewList(filteredStations));
      dispatch(setChargingNewListStations(true));
    }
  }, [dataAPI.data, dispatch]);

  // ================= View =========================

  return (
    <>
      <div className="ag-theme-alpine dataGrid">
        <AgGridReact
          ref={gridRef}
          className="dataGrid"
          columnDefs={columns}
          rowData={rows}
          defaultColDef={defaultColDef}
          reactiveCustomComponents
          rowSelection="multiple"
          onSelectionChanged={onSelectionChanged}
          onFilterModified={onFilterModified}
          onFilterChanged={onFilterChanged}
          onCellMouseOver={cellRenderer}
          onCellMouseOut={cellRendererOut}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={doesExternalFilterPass}
        />
      </div>
      <div className="totalItems">
        Total Stations: {stateRowsDataGrid.length}
        {markerSelectedArray.length > 0 && ` (selected station(s): ${markerSelectedArray.length})`}
      </div>
    </>
  );
}
export default DataGrid;
